import type { BusinessLineInterface } from '@/modules/common/common/models/DXP/BranchesData'
import { useCommonStore } from '@/modules/core/stores/commonStore'
import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import type { NavigationGuardNext, RouteLocationNormalized, RouteLocationRaw } from 'vue-router'

export function hideHeader() {
  useLoadingStore().hideHeader()
}

export function activeMock() {
  useLoadingStore().activeMock()
}

export async function raterGuard(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
) {
  const mediatorRedirect = await resolveMediator(to)
  if (mediatorRedirect) {
    next(mediatorRedirect)
    return
  }

  useCommonStore().showLogo = true
  const isPymes = to.meta.isPymes as boolean
  if (await _checkRoute(to.meta.branchName as string, isPymes)) {
    next()
  } else {
    next({ name: `rater-nav${isPymes ? '-pymes' : ''}` })
    useLoadingStore().stopLoading()
  }
}

async function _checkRoute(branchName: string, isPymes = false) {
  const data: { [key: string]: BusinessLineInterface } | null = isPymes
    ? await useCommonStore().fetchPymesBranchesData()
    : await useCommonStore().fetchBranchesData()
  return !!(data && data[branchName] && data[branchName].active)
}

export async function resolveMediator(
  to: RouteLocationNormalized
): Promise<RouteLocationRaw | void> {
  const mediatorCode = to.query.mCode as string | undefined
  if (!mediatorCode) {
    return
  }

  const commonStore = useCommonStore()
  const mediator = await commonStore.getInfoMediator(mediatorCode)
  const branchName = to.meta.branchName as string | undefined
  if (!mediator || (branchName && !commonStore.isBranchAllowedForMediator(branchName))) {
    commonStore.clearInfoMediator()
    const cleanedQuery = { ...to.query }
    delete cleanedQuery.mCode
    return {
      path: to.path,
      query: cleanedQuery,
      hash: to.hash,
      replace: true
    }
  }
}
